import { WorkRequestEditConfig } from '../shared/models/WorkRequestEditConfig';
import TaskTypes = Boo.Objects.Enums.TaskTypeEnum;
import WebsiteUrlStatuses = Boo.Objects.Enums.WebsiteUrlStatuses;
import { FileExtensions } from '../shared/file-extensions';

export default class WorkRequestEditConfigFactory {
  static allowNoWebsiteOption: TaskTypes[] = [
    Boo.Objects.Enums.TaskTypeEnum.KeywordResearchStrategyUpdate
  ];

  static shouldHideWebsiteUrl: TaskTypes[] = [
    Boo.Objects.Enums.TaskTypeEnum.KeywordResearchStrategyUpdate
  ];

  static requiresActiveHomepage: TaskTypes[] = [
    Boo.Objects.Enums.TaskTypeEnum.EntitySchema
  ];

  static shouldHideFiles: TaskTypes[] = [
    Boo.Objects.Enums.TaskTypeEnum.OnsiteRecommendation,
    Boo.Objects.Enums.TaskTypeEnum.OnsiteRecommendationAndImplementation,
    Boo.Objects.Enums.TaskTypeEnum.KeywordResearchStrategyUpdate
  ];

  static shouldHideDescription: TaskTypes[] = [
    Boo.Objects.Enums.TaskTypeEnum.StandardOnsiteCopyCreationContentOnly,
    Boo.Objects.Enums.TaskTypeEnum.StandardOnsiteCopyCreationAndImplementation,
    Boo.Objects.Enums.TaskTypeEnum.OnsiteCopy,
    Boo.Objects.Enums.TaskTypeEnum.PageCreation,
    Boo.Objects.Enums.TaskTypeEnum.PageOptimization
  ];

  static allowsSpreadsheetUploads: TaskTypes[] = [
    Boo.Objects.Enums.TaskTypeEnum.ThreeHundredOneRedirectMappingAndImplementation
  ];

  static getRestrictedWebsiteUrlStatuses(workTypeCreationId: TaskTypes): WebsiteUrlStatuses[] {
    switch (workTypeCreationId) {
      case Boo.Objects.Enums.TaskTypeEnum.PageCreation:
      case Boo.Objects.Enums.TaskTypeEnum.PageCreationImplementation:
        return [
          Boo.Objects.Enums.WebsiteUrlStatuses.Target,
          Boo.Objects.Enums.WebsiteUrlStatuses.Supporting,
          Boo.Objects.Enums.WebsiteUrlStatuses.Archived
        ];
      case Boo.Objects.Enums.TaskTypeEnum.PageOptimization:
      case Boo.Objects.Enums.TaskTypeEnum.PageOptimizationImplementation:
        return [
          Boo.Objects.Enums.WebsiteUrlStatuses.New,
          Boo.Objects.Enums.WebsiteUrlStatuses.Archived
        ];
      default:
        return [];
    }
  }

  static create(workTypeCreationId: TaskTypes): WorkRequestEditConfig {
    return {
      allowNoWebsiteOption : WorkRequestEditConfigFactory.allowNoWebsiteOption.includes(workTypeCreationId),
      shouldHideDescription : WorkRequestEditConfigFactory.shouldHideDescription.includes(workTypeCreationId),
      shouldShowWebsiteUrl : !WorkRequestEditConfigFactory.shouldHideWebsiteUrl.includes(workTypeCreationId),
      shouldShowFiles : !WorkRequestEditConfigFactory.shouldHideFiles.includes(workTypeCreationId),
      acceptedFileExtensions : WorkRequestEditConfigFactory.allowsSpreadsheetUploads.includes(workTypeCreationId) ? FileExtensions.defaultsWithSpreadsheets() : FileExtensions.defaults(),
      restrictedWebsiteUrlStatuses : WorkRequestEditConfigFactory.getRestrictedWebsiteUrlStatuses(workTypeCreationId),
      requiresActiveHomepage : WorkRequestEditConfigFactory.requiresActiveHomepage.includes(workTypeCreationId)
    };
  }
}
